<template>
    <v-text-field 
        :value="value" 
        @change="onChange" @input="onInput" @keydown="$emit('keydown')" @blur="$emit('blur')" @click="$emit('click')"
        outlined dense hide-details="auto" 
        :label="label" 
        :disabled="readonly" 
        :background-color="backgroundColorAdjusted" 
        :rules="rules" 
        :class="!!value ? 'c-text-field' : 'c-text-field-empty'"
        :clearable="clearable"                 
        @click:clear="$emit('click:clear')"     
    >
        <template v-slot:append>
          <slot name="append"></slot>
        </template>
    </v-text-field>
</template>

<script>
export default {
props: {
    value: [String, Number],
    readonly: Boolean,
    label: String,
    rules: Array,
    backgroundColor: String,
    clearable: Boolean
},

methods: {
    onInput (event) {
        this.$emit('input', event)
    },
    onChange (event) {
        this.$emit('change', event)
    }
},
computed: {
    backgroundColorAdjusted () {
            if (this.backgroundColor){
                return this.backgroundColor;
            }
            else if (this.readonly){
                return 'grey lighten-4';
            }
            else {
                return null;
            }
            // return this.backgroundColor ?? this.readonly ? 'grey lighten-4' : null;
        }
}
}
</script>

<style scoped>
.v-text-field >>> label {
  color: black;
}
.c-text-field >>> input {
  color: black;
}
.c-text-field-empty >>> label {
    color: darkslategrey;
}
</style>